import { supabase } from '@/integrations/supabase/client';

export interface VenueRate {
  id: string;
  venue_id: string;
  facility_type: string;
  hourly_rate: number;
  daily_rate?: number;
  peak_hour_multiplier: number;
  created_at: string;
  updated_at: string;
}

export const venueRatesService = {
  async getVenueRates(venueId: string): Promise<VenueRate[]> {
    const { data, error } = await supabase
      .from('venue_rates')
      .select('*')
      .eq('venue_id', venueId)
      .order('facility_type');

    if (error) {
      console.error('Error fetching venue rates:', error);
      return [];
    }

    return data || [];
  },

  async createVenueRate(venueId: string, rateData: {
    facility_type: string;
    hourly_rate: number;
    daily_rate?: number;
    peak_hour_multiplier?: number;
  }): Promise<VenueRate | null> {
    const { data, error } = await supabase
      .from('venue_rates')
      .insert({
        venue_id: venueId,
        ...rateData
      })
      .select()
      .single();

    if (error) {
      console.error('Error creating venue rate:', error);
      return null;
    }

    return data;
  },

  async updateVenueRate(rateId: string, updates: Partial<{
    facility_type: string;
    hourly_rate: number;
    daily_rate: number;
    peak_hour_multiplier: number;
  }>): Promise<VenueRate | null> {
    const { data, error } = await supabase
      .from('venue_rates')
      .update(updates)
      .eq('id', rateId)
      .select()
      .single();

    if (error) {
      console.error('Error updating venue rate:', error);
      return null;
    }

    return data;
  },

  async deleteVenueRate(rateId: string): Promise<boolean> {
    const { error } = await supabase
      .from('venue_rates')
      .delete()
      .eq('id', rateId);

    if (error) {
      console.error('Error deleting venue rate:', error);
      return false;
    }

    return true;
  }
};